var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendWithGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10628_3834)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16375 12C5.16375 11.2379 5.29033 10.5072 5.51625 9.82186L1.56184 6.80212C0.791149 8.36692 0.356934 10.1301 0.356934 12C0.356934 13.8683 0.790615 15.6304 1.56024 17.1941L5.51251 14.1685C5.28873 13.4864 5.16375 12.7584 5.16375 12Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1069 5.0666C13.7625 5.0666 15.258 5.65327 16.433 6.61327L19.8512 3.19993C17.7682 1.3866 15.0978 0.266602 12.1069 0.266602C7.46347 0.266602 3.47274 2.92207 1.56177 6.80207L5.51618 9.8218C6.42734 7.05594 9.02462 5.0666 12.1069 5.0666Z",
    fill: "#EB4335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1069 18.9333C9.02462 18.9333 6.42734 16.944 5.51618 14.1781L1.56177 17.1973C3.47274 21.0778 7.46347 23.7333 12.1069 23.7333C14.9728 23.7333 17.7089 22.7157 19.7625 20.809L16.0089 17.9072C14.9498 18.5744 13.6162 18.9333 12.1069 18.9333Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3228 11.9999C23.3228 11.3066 23.216 10.5599 23.0558 9.86658H12.1069V14.3999H18.4092C18.0941 15.9455 17.2363 17.1338 16.009 17.9071L19.7626 20.809C21.9198 18.8068 23.3228 15.8244 23.3228 11.9999Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10628_3834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWithGoogleIcon);
export default __webpack_public_path__ + "static/media/sendWithGoogleIcon.cdc468f2c2023707899b491d5eac6730.svg";
export { ForwardRef as ReactComponent };